import clinicLogo from "../Assets/Images/clinic.svg";
import doctorLogo from "../Assets/Images/Doctor.svg";

const images = {
  clinicLogo,
  doctorLogo,
};

export default images;
